import type {Headers} from '@sail/data';

import type {StripeContextInput as V2ContextInput} from '../../schema/types';
import isModelessId from './permissions/isModelessId';

const ACCOUNT_HEADER = 'Stripe-Account';
const AUTHORIZATION_HEADER = 'Authorization';
const CONTEXT_HEADER = 'Stripe-Context';
const LIVEMODE_HEADER = 'Stripe-Livemode';

export default function addContextHeaders(
  headers: Headers,
  v2Context: V2ContextInput,
  endpoint: string,
) {
  const {apiKey, id, liveMode} = v2Context;

  // Force Stripe-Account in cases where Stripe-Context was set by something
  // else.
  if (id && !headers.get(CONTEXT_HEADER)) {
    headers.set(CONTEXT_HEADER, id);
  }

  // This is done here to cover the case where someone has already set the
  // header.
  const finalValue = headers.get(CONTEXT_HEADER);

  if (finalValue && endpoint !== '/ajax/graphql') {
    // This has to be here until we remove graphql gateway tunneling through
    // manage on devbox. This further forks prod behavior but it's unavoidable.
    // Check back with @alusco on this by end Q1 2026, we are hoping to remove
    // the need for this. See #ir-akin-stack as a reason this has to be here.
    headers.set(ACCOUNT_HEADER, finalValue);
  }

  if (!finalValue) {
    // Set it for Edge priority.
    headers.set(LIVEMODE_HEADER, 'true');
  } else if (
    !isModelessId(finalValue) &&
    liveMode &&
    !headers.get(LIVEMODE_HEADER)
  ) {
    // Set it for the requested live mode (e.g. for an account).
    headers.set(LIVEMODE_HEADER, liveMode === 'FORCE_TEST' ? 'false' : 'true');
  }

  // Set Bearer authentication when apiKey is provided
  if (apiKey && !headers.get(AUTHORIZATION_HEADER)) {
    headers.set(AUTHORIZATION_HEADER, `Bearer ${apiKey}`);
  }
}
